import { computed } from "vue";
import { useStore } from "vuex";
const SurveyItemTableViewMixin = {
  props: {
    item: Object,
    value: null
  },
  setup() {
    const store = useStore("banza-survey");
    const showValues = computed(() => store.state.results.showValues);
    return {
      showValues
    };
  }
};
export {
  SurveyItemTableViewMixin as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3VydmV5SXRlbVRhYmxlVmlld01peGluLmpzIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbWl4aW5zL1N1cnZleUl0ZW1UYWJsZVZpZXdNaXhpbi50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBJQmFzZVF1ZXN0aW9uIH0gZnJvbSBcIkAvdHlwZXMvUXVlc3Rpb25cIjtcbmltcG9ydCB7IGRlZmluZVByb3BzLCBjb21wdXRlZCwgUHJvcFR5cGUgfSBmcm9tIFwidnVlXCI7XG5pbXBvcnQgeyB1c2VTdG9yZSB9IGZyb20gXCJ2dWV4XCI7XG5cbmV4cG9ydCBkZWZhdWx0IHtcbiAgcHJvcHM6IHtcbiAgICBpdGVtOiBPYmplY3QgYXMgUHJvcFR5cGU8SUJhc2VRdWVzdGlvbj4sXG4gICAgdmFsdWU6IG51bGwsXG4gIH0sXG4gIHNldHVwKCkge1xuICAgIGNvbnN0IHN0b3JlID0gdXNlU3RvcmUoXCJiYW56YS1zdXJ2ZXlcIik7XG4gICAgY29uc3Qgc2hvd1ZhbHVlcyA9IGNvbXB1dGVkKCgpID0+IHN0b3JlLnN0YXRlLnJlc3VsdHMuc2hvd1ZhbHVlcyk7XG5cbiAgICByZXR1cm4ge1xuICAgICAgc2hvd1ZhbHVlcyxcbiAgICB9O1xuICB9LFxufTtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUlBLE1BQWUsMkJBQUE7QUFBQSxFQUNiLE9BQU87QUFBQSxJQUNMLE1BQU07QUFBQSxJQUNOLE9BQU87QUFBQSxFQUNUO0FBQUEsRUFDQSxRQUFRO0FBQ0EsVUFBQSxRQUFRLFNBQVMsY0FBYztBQUNyQyxVQUFNLGFBQWEsU0FBUyxNQUFNLE1BQU0sTUFBTSxRQUFRLFVBQVU7QUFFekQsV0FBQTtBQUFBLE1BQ0w7QUFBQSxJQUNGO0FBQUEsRUFBQTtBQUVKOyJ9
